import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { ShariahServiceProvider } from "../../providers/shariah-service/shariah-service";

/**
 * Generated class for the ContactusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-contactus",
  templateUrl: "contactus.html"
})
export class ContactusPage {
  contact: any;
  img: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private shariahService: ShariahServiceProvider
  ) {}

  async ngOnInit() {
    await this.getAboutUs();
  }

  async getAboutUs() {
    await this.shariahService.getAboutUs().subscribe(
      (data: any) => {
        console.log(data);
        this.img = data.contact_img;
      },
      err => console.log(err)
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contactus/contactus.ts